<template>
  <v-card class="diario-data-table-card my-4">
    <v-card-title>
      <span class="pa-1 table-card-title">Faturamento {{ formatDate($route.params.mes) }}</span>
    </v-card-title>
    <mf-loading :loader="['itens', 'cupons']" loader-type="table">
      <v-card-text v-shortkey="['ctrl', 'alt', 'e']" @shortkey="exportarCsv()">
        <v-data-table :headers="headers" :items="tableData" hide-default-footer disable-pagination>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item['NUM_DIA_PAD'] }} <span v-if="item['NUM_SEMANA']">- {{ item['NUM_SEMANA'] }}</span>
              </td>
              <td class="text-right">{{ item['VAL_FATURAMENTO'] | localeString(2) | currency }}</td>
              <td class="text-right">
                <listagem :value="item['NUM_CUPONS']" :dia-selecionado="mesAnoListagem(item['NUM_DIA'])" />
              </td>
              <td class="text-right">{{ item['NUM_ITENS'] | localeString }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </mf-loading>
  </v-card>
</template>

<script>
import orderBy from 'lodash/orderBy'
import merge from 'lodash/merge'
import capitalize from 'lodash/capitalize'
import Listagem from '@/components/ListagemCupons.vue'
import { calculateTotal } from '@/config/helpers'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { assertArray } from '@/config/helpers.js'
import { DateTime } from 'luxon'

export default {
  components: {
    Listagem,
  },
  props: {
    listaFaturamento: Array,
  },
  data: () => ({
    listaItens: [],
    listaCupons: [],
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    headers() {
      return [
        {
          text: 'Dia',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Faturamento',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Cupons',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Itens',
          sortable: false,
          align: 'right',
        },
      ]
    },
    tableData() {
      const faturamento = orderBy(this.listaFaturamento, 'NUM_DIA', 'asc')
      const itens = orderBy(this.listaItens, 'NUM_DIA', 'asc')
      const cupons = orderBy(this.listaCupons, 'NUM_DIA', 'asc')
      return calculateTotal(merge(faturamento, itens, cupons), ['VAL_FATURAMENTO', 'NUM_CUPONS', 'NUM_ITENS'], 'NUM_DIA')
    },
  },
  async mounted() {
    await this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getData)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      empresaItens: 'itens',
      empresaCupons: 'cupons',
    }),
    getData() {
      const filter = {
        fidelidade: this.stateFilters.fidelidade,
        unidades: this.stateFilters.unitsConfiguration,
        tipo_pessoa: this.stateFilters.pessoa,
        categoria_cliente: this.stateFilters.cliente,
        group_field: 'dia',
        date: this.$route.params.mes,
        segmentos: this.stateFilters.segments,
        produto: this.stateFilters.products,
      }

      this.empresaItens(filter).then((data) => {
        this.listaItens = assertArray(data)
      })
      this.empresaCupons(filter).then((data) => {
        this.listaCupons = assertArray(data)
      })
    },
    mesAnoListagem(day) {
      return `${this.$route.params.mes}-${String(day).padStart(2, '0')}`
    },
    formatDate(value) {
      return capitalize(DateTime.fromFormat(value, 'yyyy-MM').setLocale('pt-BR').toFormat("MMMM 'de' yyyy"))
    },
    exportarCsv() {
      let array = [[`Dia do mês de ${this.formatDate(this.$route.params.mes)}`, 'Faturamento', 'Cupons', 'Itens']]

      for (let object of this.tableData) {
        array.push([object['NUM_DIA'], object['VAL_FATURAMENTO'], object['NUM_CUPONS'], object['NUM_ITENS']])
      }

      let csvContent = 'data:text/csv;charset=utf-8,'
      array.forEach(function (rowArray) {
        let row = rowArray.join(';')
        csvContent += row + '\r\n'
      })

      let encodedUri = encodeURI(csvContent)
      let link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'my_data.csv')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
    },
  },
}
</script>

<style lang="scss">
.diario-data-table-card {
  min-height: 240px;
}
</style>
